import { html } from '@microsoft/fast-element';
const conditionalSchemaEntry = (predicate, entry) => {
    return predicate ? [entry] : [];
};
const editUserSchema = (edit, allAccessType, entityID, entityLabel, entityLabelKey, availableEntitiesEndpoint, additionalEntries = []) => ({
    type: 'VerticalLayout',
    elements: [
        {
            type: 'Control',
            label: 'Username',
            scope: '#/properties/USER_NAME',
            options: {
                readonly: edit,
            },
        },
        {
            type: 'Control',
            label: 'Email',
            scope: '#/properties/EMAIL_ADDRESS',
        },
        {
            type: 'Control',
            label: 'First Name',
            scope: '#/properties/FIRST_NAME',
        },
        {
            type: 'Control',
            label: 'Last Name',
            scope: '#/properties/LAST_NAME',
        },
        ...conditionalSchemaEntry(!edit, {
            type: 'Control',
            label: 'One Time Password',
            scope: '#/properties/ONE_TIME_PASSWORD',
        }),
        {
            type: 'Control',
            label: 'User Profiles',
            scope: '#/properties/USER_PROFILES',
            options: {
                allOptionsResourceName: 'ALL_PROFILES',
                valueField: 'PROFILE_NAME',
                labelField: 'PROFILE_NAME',
            },
        },
        ...conditionalSchemaEntry(!!entityID, {
            type: 'Control',
            label: 'Access Type',
            scope: '#/properties/ACCESS_TYPE',
            options: {
                hidden: !allAccessType,
            },
        }),
        ...conditionalSchemaEntry(!!entityID, {
            type: 'Control',
            scope: `#/properties/${entityID}`,
            options: {
                allOptionsResourceName: availableEntitiesEndpoint,
                valueField: entityID,
                labelField: entityLabelKey || entityID,
                hidden: !allAccessType,
            },
            label: entityLabel,
        }),
        ...additionalEntries.map((entry) => typeof entry === 'string'
            ? {
                type: 'Control',
                scope: `#/properties/${entry}`,
            }
            : entry),
    ],
});
export const UsersTemplate = html `
  <entity-management
    resourceName=${(x) => x.resourceName}
    title="User Management"
    entityLabel="User"
    createEvent="${(x) => x.createEvent}"
    :readEventFn=${(x) => (user) => x.readUserData(user)}
    updateEvent="${(x) => x.updateEvent}"
    deleteEvent="${(x) => x.deleteEvent}"
    entityLabel="User Details"
    :updateFormUiSchema=${(x) => editUserSchema(true, x.allAccessType, x.entityID, x.entityLabel, x.entityLabelKey, x.availableEntitiesEndpoint, x.additionalUpdateFields)}
    :createFormUiSchema=${(x) => editUserSchema(false, x.allAccessType, x.entityID, x.entityLabel, x.entityLabelKey, x.availableEntitiesEndpoint, x.additionalCreateFields)}
    persist-column-state-key=${(x) => x.persistColumnStateKey}
    size-columns-to-fit
    :columns=${(x) => [...x.columns, ...x.entityColumn(), x.statusColumn()]}
    :datasourceConfig=${(x) => x.datasourceConfig}
  ></entity-management>
`;
